import { createSlice } from '@reduxjs/toolkit';
import { ControlCoverageLimitsSubQuestionReducer } from '../../reducers/ControlCoverageLimitsSubQuestionReducer';
import { CurrencyTypes } from '../../../core/enums/CurrencyTypes';

const initialState: any = {
	limits: {
		model: null,
		limit1: { currency: CurrencyTypes.BRL },
		limit2: { currency: CurrencyTypes.BRL },
		limit3: { currency: CurrencyTypes.BRL },
	},
	prefixes: {
		limit1: {},
		limit2: {},
		limit3: {},
	},
};

export const controlCoverageLimitsSubQuestion = createSlice({
	name: 'control-coverage',
	initialState,
	reducers: ControlCoverageLimitsSubQuestionReducer,
});

export const { addLimits, addPrefixes, cleanCoverageLimits } =
	controlCoverageLimitsSubQuestion.actions;

export default controlCoverageLimitsSubQuestion.reducer;
